import axios from 'axios';

const TIMEOUT_ERROR_MESSAGE = 'timeoutErrorMessage';

axios.defaults.timeout = 50000;
axios.defaults.timeoutErrorMessage = TIMEOUT_ERROR_MESSAGE;

let instance = axios.create({
  baseURL: process.env.REACT_APP_API_LINK_COMMUNICATED,
});

instance.interceptors.request.use(
  async (config) => {
    config.headers = {
      'Content-Type': 'application/json',
      apiKey: process.env.REACT_APP_API_KEY_COMMUNICATED,
      'Access-Control-Allow-Origin': '*',
    };
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const http = instance;
